import React, { useEffect, useState } from "react";
import {
  Collapse,
  Table,
  Tag,
} from "antd";

const EventPartners = ({ data }) => {

  const [partners, setPartners] = useState([]);
  const [expandIconPosition, setExpandIconPosition] = useState("start");


  const { Panel } = Collapse;

  useEffect(() => {
    loadObjectives()
  }, [])

  const loadObjectives = () => {

    setPartners(data)
  }

  const columns = [
    { title: "Name", dataIndex: "name", key: "1", responsive: ["sm"] },
    {
      title: "Type", dataIndex: "partnerType", key: "2", responsive: ["sm"],
      render: (_, { partnerType }) => {

        return (
          <> {partnerType.value}</>
        );
      }
    },
    { title: "Contact No", dataIndex: "telephoneNumber", key: "3", responsive: ["sm"] },
    { title: "Email Address", dataIndex: "email", key: "4", responsive: ["sm"] },
    {
      title: "Address", dataIndex: "address", key: "5", responsive: ["sm"],
      render: (_, { address }) => {
        return (
          <div>
            {`${address.street} ${address.cityOrTown} ${address.province} ${address.postalCode}, ${address.country}`}
          </div>
        )

      }
    },
    {
      title: "Contribution", dataIndex: "detailContributions", key: "6", responsive: ["sm"],
      render: (_, { detailContributions }) => (
        <>
          {detailContributions.map((contribution) => {
            let color = contribution.key == 10 ? 'geekblue' : contribution.key == 11 ? 'green' : contribution.key == 12 ? 'blue' : contribution.key == 13 ? 'red' : 'cyan';
            return (
              <Tag color={color} key={contribution.key}>
                {contribution.value}
              </Tag>
            );
          })}
        </>
      ),
    },

  ];

  return (
    <>
      <Collapse key="1a" expandIconPosition={expandIconPosition} >
        <div>
          <Table
            dataSource={partners}
            columns={columns}
            rowKey={(x)=>x.name}
            bordered
            pagination={{ pageSize: 10 }}
          />
        </div>
      </Collapse>
    </>
  )
}

export default EventPartners